type EnumLiteralsOf<T extends object> = T[keyof T];
export const OPERATE = Object.freeze({
  INCLUDE: 'include',
  EXCLUDE: 'exclude',
  PREFERRED: 'preferred',
  NONPREFERRED: 'nonPreferred',
});
export type OPERATES = EnumLiteralsOf<typeof OPERATE>;
